import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetPersonParentChildByMemberIdData = (memberId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    let newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      objData: [],
      message: 'Loading...'
    };
    setState(newState);

    const memberIdForUrl = memberId ? encodeURIComponent(memberId) : 'NaN';
    const url = `/PersonParentChild/Member/${memberIdForUrl}/Status`;
    PersonHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: '',
          };
          setState(newState);
          return objData;
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default GetPersonParentChildByMemberIdData;